import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { useExperienceModuleContext, useSelectedEntityVenues } from 'modules/experience-core';
import { ExperienceEntityType, NavigationItem } from 'modules/experience-core';

import {
  BEST_OF_WOLT_NAVIGATION_ITEM,
  BUSINESS_DETAILS_NAVIGATION_ITEM,
  CAMPAIGNS_NAVIGATION_ITEM,
  MENU_EDITOR_NAVIGATION_ITEM,
  PURCHASES_NAVIGATION_ITEM,
  SETTLEMENTS_NAVIGATION_ITEM,
  TRANSLATION_NAVIGATION_ITEM,
} from '../constants';

export const useVenueNavigationItems = (): NavigationItem[] => {
  const {
    experienceEntity: { experienceEntityType },
  } = useExperienceModuleContext();
  const venues = useSelectedEntityVenues();
  const filteredVenues = venues.filter(
    venueExperienceEntity => (venueExperienceEntity.experienceEntityObject as Venue).status === 'VENUE_PUBLISHED',
  );
  if (filteredVenues.length === 0) {
    return [];
  }
  // TODO: Begin: Implement logic to determine if best of wolt navigation should be shown
  const shouldShowBestOfWoltNavigation = true;
  const shouldShowBusinessDetailsNavigation = true;
  const shouldShowPurchaseNavigation = true;
  const shouldShowTranslationNavigation = true;
  const shouldMenuEditorNavigation = true;
  const shouldShowCampaignNavigation = experienceEntityType === ExperienceEntityType.VENUE;
  const shouldShowSettlementsNavigation = true;

  // TODO: End: Implement logic to determine if best of wolt navigation should be shown

  const campaignsNavigationItem = {
    ...CAMPAIGNS_NAVIGATION_ITEM,
    isVenueSpecific: true,
  };

  return [
    ...(shouldShowBestOfWoltNavigation ? [BEST_OF_WOLT_NAVIGATION_ITEM] : []),
    ...(shouldShowBusinessDetailsNavigation ? [BUSINESS_DETAILS_NAVIGATION_ITEM] : []),
    ...(shouldShowPurchaseNavigation ? [PURCHASES_NAVIGATION_ITEM] : []),
    ...(shouldShowTranslationNavigation ? [TRANSLATION_NAVIGATION_ITEM] : []),
    ...(shouldShowCampaignNavigation ? [campaignsNavigationItem] : []),
    ...(shouldMenuEditorNavigation ? [MENU_EDITOR_NAVIGATION_ITEM] : []),
    ...(shouldShowSettlementsNavigation ? [SETTLEMENTS_NAVIGATION_ITEM] : []),
  ];
};
